import { COLLISION_COLOURS, COLLISION_GROUPS } from '../../../constants/Constants';
import { GameEvents } from '../../GameEvents';
import { CollisionCollider } from '../collisions/CollisionCollider';

export class WorldProjectile extends Phaser.GameObjects.Image {
  constructor(scene, layer, config) {
    super(scene, config.x, config.y, 'game_graphics', config.sprite);
    scene.add.existing(this);
    this.setOrigin(0.5);
    if (layer) layer.add(this);
    this._type = config.type || 'projectile';
    this._lifespan = 0;
    this._startPos = this.x;
    this._damage = config.damage;
    this._depth = config.depth;
    this._knockdown = config.knockdown;
    this._type = config.type;
    this._velocity = config.velocity;
    this.scaleX = this._velocity.x > 0 ? 1 : -1;

    this._attackCollider = new CollisionCollider(scene, {
      x: this.x - this.displayWidth * 0.5,
      y: this.y - this.displayHeight * 0.5,
      sensor: true,
      width: this.width,
      height: this.height,
      gameObject: this,
      depth: config.depth,
      debugColour: COLLISION_COLOURS.PROJECTILE,
      collisionGroup: config.isHero
        ? COLLISION_GROUPS.PROJECTILE_HERO
        : COLLISION_GROUPS.PROJECTILE_ENEMY,
      collidesWith: config.isHero ? COLLISION_GROUPS.ENEMY_BODY : COLLISION_GROUPS.HERO_BODY, //TODO : WHat if is a hero projectile
    });

    this._heroTarget = scene.hero;

    if (this._type === 'mine') {
      this.scaleY = 0;
      scene.tweens.add({
        targets: this,
        scaleY: 1,
        duration: 250,
        ease: Phaser.Math.Easing.Back.Out,
      });
    }
    scene.events.on('update', this.update, this);
  }

  update(time, delta) {
    delta /= 1000;

    switch (this._type) {
      case 'mine':
        this.updateMine(time, delta);
        break;
      default:
        this.updateProjectile(time, delta);
        break;
    }
  }

  updateMine(time, delta) {
    if (this.scaleY === 1) {
      this.alpha -= 1 * delta;
      this._attackCollider.enabled = false;
      if (this.alpha <= 0) {
        this.destroy();
      }
    } else this.checkCollisions();
  }

  updateProjectile(time, delta) {
    this.x += this._velocity.x * delta;
    if (this._velocity.y !== 0) {
      this.y += this._velocity.y * delta;
      this._attackCollider.depth += this._velocity.y * delta;
    }
    this._attackCollider.x = this.x - this.displayWidth * 0.5;
    this._attackCollider.y = this.y - this.displayHeight * 0.5;
    if (this.checkCollisions()) return;
    if (Math.abs(this._startPos - this.x) > 2000) this.destroy();
  }

  checkCollisions() {
    if (!this._attackCollider) return false;
    const collisions = this._attackCollider.getCollisions();
    if (collisions?.length) {
      collisions[0].gameObject.damage(this._damage, {
        knockdown: this._knockdown,
      });
      this.scene.game.soundController.playSFX('sfx', 'hit_impact');
      this.scene.events.emit(GameEvents.PLAYER_ATTACK_HIT, {
        x: this.x,
        y: this.y,
        dir: this.scaleX,
      });
      this.destroy();
      return true;
    }
    return false;
  }

  destroy() {
    this._attackCollider.destroy();
    this._attackCollider = null;
    this.scene.events.off('update', this.update, this);
    super.destroy();
  }
}
